import { apiClient } from "../../../../../api/client";
import { ApiResponse } from "../../../../../types";
import {
  ImileFranquiaListParams,
  ImileFranquiaRegistrationParams,
  ImileFranquiaResponse,
  ImileFranquiaUpdateParams,
} from "../types";

/**
 * ATENÇÃO ao contrato de dbName, herdado dos irmãos do entrego:
 *  - /gestorImileCadastroFranquia recebe o banco inteiro ("xama_dev");
 *  - /gestorImileCadastroViz recebe só o fundo ("xama") e concatena o stage.
 * A divergência existe no entrego e foi mantida para as duas telas ficarem
 * simétricas. Não "consertar" um lado só.
 */
export const imileFranquiaService = {
  async registerFranquia(
    params: ImileFranquiaRegistrationParams
  ): Promise<ApiResponse<string>> {
    return apiClient.post("/gestorImileCadastroFranquia", params);
  },

  async updateFranquia(
    params: ImileFranquiaUpdateParams
  ): Promise<ApiResponse<string>> {
    return apiClient.post("/gestorImileCadastroFranquia", params);
  },

  async getFranquias(
    params: ImileFranquiaListParams
  ): Promise<ApiResponse<{ data: ImileFranquiaResponse[] }>> {
    return apiClient.post("/gestorImileCadastroViz", params);
  },
};
